import React from 'react';

const Footer = () => {
  return (
    <div className="bg-gray-50 border-t border-gray-200 px-4 py-4">
      <div className="flex items-center justify-center space-x-4 text-xs text-gray-600">
        <img 
          src="/ieta_footer_optimized.png" 
          alt="IETA - Indian Experts Training Academy" 
          className="h-7 w-auto object-contain"
        />
        <span className="text-center leading-relaxed">
          All rights reserved - Ms. Shital Thakkar Director of Indian Experts Training Academy Pvt. Ltd. 
          (authorised legal entity of NIF Global Pimpri Chinchwad)
        </span>
      </div>
    </div>
  );
};

export default Footer;